import { List, ListItem } from '@mui/material';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';

import { BackButton } from '../components/buttons/BackButton';
import { useStats } from '../utils/stats';

interface StatsTileProps {
  value: number;
  name: string;
}

const Type = styled(Typography)`
  margin-top: 5px !important;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 100%;
  gap: 12px;
  padding-left: 12px;
  padding-right: 12px;
  margin-top: 20px;
`;

function StatsTile({ value, name }: StatsTileProps) {
  return (
    <div className="flex flex-col m-2 max-w-min">
      <p className="text-3xl font-bold text-center">{value}</p>
      <p className="text-center">{name}</p>
    </div>
  );
}

export const StatsRoute = () => {
  const [{ played, winCount, currentStreak, maxStreak, guessDistribution }] =
    useStats();
  const { t } = useTranslation();

  const winRatio = winCount / (played || 1);

  const maxDistribution = Math.max(...Object.values(guessDistribution));

  return (
    <>
      <Container>
        <BackButton />

        <div className="mt-4 w-full">
          <h3 className="text-xl font-bold text-center">{t('stats.title')}</h3>
          <div className="flex justify-center">
            <StatsTile value={played} name={t('stats.played')} />
            <StatsTile
              value={Math.round(winRatio * 100)}
              name={t('stats.win')}
            />
            <StatsTile value={currentStreak} name={t('stats.currentStreak')} />
            <StatsTile value={maxStreak} name={t('stats.maxStreak')} />
          </div>
          <div className="my-6">
            <h3 className="text-xl font-bold text-center">
              {t('stats.guessDistribution')}
            </h3>

            <List>
              {guessDistribution.map((count, index) => (
                <ListItem sx={{ paddingBottom: 0 }} key={index}>
                  <div>{index + 1}</div>
                  <div
                    className="flex-shrink-0 flex-grow bg-gray-300 p-0.5 px-1.5 rounded-sm ml-2 dark:text-black"
                    style={{
                      flex: `0 1 ${Math.round((count / maxDistribution) * 100)}%`,
                    }}
                  >
                    {count}
                  </div>
                </ListItem>
              ))}
            </List>
          </div>
        </div>
      </Container>

      <Type id="modal-modal-description" sx={{ m: 2 }}>
        <Button
          variant="contained"
          onClick={() => {
            window.open('https://crisisrelief.un.org/t/ukraine');
          }}
        >
          {t('stats.donate')}
        </Button>
      </Type>
    </>
  );
};

export default StatsRoute;
